import TextField from '@material-ui/core/TextField'
import React, { useState } from 'react'
import useLocale from '../../../customHooks/useLocale'
import { getLocalizedValue } from '../../../utils/localeUtils'

const NumberTypePreview = ({ question }) => {
  const [inputtedNumber, setValue] = useState('')
  const locale = useLocale()

  return (
    <div>
      <form>
        <TextField
          id='number'
          label={getLocalizedValue(question.placeholder, locale)}
          type='number'
          min={question.min}
          max={question.max}
          onInput={(e) => {
            e.target.value = Math.max(0, parseInt(e.target.value))
              .toString()
              .slice(0, question.maxlength)
          }}
          required={question.required}
          value={inputtedNumber}
          onChange={(e) => setValue(e.target.value)}
          error={
            inputtedNumber.length !== 0 &&
            (inputtedNumber < question.min || inputtedNumber > question.max)
          }
        />
      </form>
    </div>
  )
}

export default NumberTypePreview
